var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHigherBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 63",
    width: 23,
    height: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 51,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAzCAMAAACg/tixAAAAAXNSR0IB2cksfwAAAHtQTFRFJH2DVZucAAAAHHh+RJCTMYWJHXl/UJiaK4GGYaSiX6OiNIaLHHh+Z6ilVOBGIXuBI3yCNoiMY6WjRZGUbqyoJX6DWZ6fZqelInyBXaGgMISIKoCFJX2Da6qnbauoLIKHVpycSpWXOYqON4mNRpOVJn6DPo2QIHqAH3p/vttj3gAAACl0Uk5T+6wA/9jx/rn2c3/v/kkA/fvsZ9Ur+p1Z/Iry+PoVOvakyOrr0frh/f5DTzgQAAABQ0lEQVR4nG3TUVOCQBAA4N0DDcxIh0zH0iYe6v//nSYnHVObckzHLDPR5G737jjggYNvlr1lWRAQwT3QAzyUIIjUxepJ/L8SdGMxkFH5vBju5Hqwa0BBd9XfEoSzrYU+b2JiUYQcEX4bPNfXXvDFCGbf+lpjtNYarRgbK1NMbUMIzaVGL1oQQrwwumeE0BQezxmhNWfMqiW0UlR2BuFqSe97tBDg+kMuIrUR2u8qNIeg+hDnUb1d20HIuttxMWtZxUH5GRp57M7k2cbbN1m+t7ew96rW2kYjhcnmMapsKpCw9aknrDOj1vXHOnHYnCi8mZoK+iOQWN+a6bwbgsL7oTb52ST6JrA7IbQy8jSiSF7YLnkoUFzQqEHwAxo5ZTIAgzSJqdUu7E3tYggfBgUDfHwumPoNHZN/sWsZFuz0ePLkGvwDe6JaERAdsgkAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-higher-bg"
  }, /*#__PURE__*/React.createElement("use", {
    id: "img1",
    href: "#img1",
    x: 1,
    y: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHigherBg);
export default __webpack_public_path__ + "static/media/ico-higher-bg.7880f6874acdeb1c98cff815c25415e0.svg";
export { ForwardRef as ReactComponent };